import type { QueryClient } from "@tanstack/react-query";

import type { QueryOptionsDTO, SortDirection } from "@/interfaces/query-options-dto";

type RouteLoaderContext = {
  context: {
    queryClient: QueryClient;
  };
};

type RouteQueryDataResult = Awaited<ReturnType<QueryClient["ensureQueryData"]>>;

type BuildDataTableQueryOptionsArgs = {
  searchString?: string;
  pageIndex?: number;
  pageSize?: number;
  sortField?: string;
  sortDirection?: SortDirection;
};

export function ensureRouteQueryData<TQueryOptions>(
  { context }: RouteLoaderContext,
  queryOptions: TQueryOptions,
): ReturnType<QueryClient["ensureQueryData"]> {
  return context.queryClient.ensureQueryData(queryOptions as never);
}

export function ensureRouteQueriesData<TQueryOptions>(
  { context }: RouteLoaderContext,
  queryOptionsList: TQueryOptions[],
): Promise<RouteQueryDataResult[]> {
  return Promise.all(
    queryOptionsList.map((queryOptions) => context.queryClient.ensureQueryData(queryOptions as never)),
  );
}

export function buildDataTableQueryOptions({
  searchString,
  pageIndex = 0,
  pageSize = 10,
  sortField,
  sortDirection,
}: BuildDataTableQueryOptionsArgs): QueryOptionsDTO {
  const queryOptions: QueryOptionsDTO = {
    pageIndex,
    pageSize,
    searchString,
  };

  if (sortField && sortDirection) {
    queryOptions.sortField = sortField;
    queryOptions.sortDirection = sortDirection;
  }

  return queryOptions;
}
